/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'message-items';
const componentName = 'vlan-interface-network';
const prefix = `${moduleName}.${componentName}`;

export const vlanInterfaceNetworkBreadcrumbTitle = `${prefix}.vlanInterfaceNetworkBreadcrumbTitle`;

export const ENGLISH = {
    [vlanInterfaceNetworkBreadcrumbTitle]: 'VLAN Interface',
};
